import { render, staticRenderFns } from "./AllBeneficiaryComponent.vue?vue&type=template&id=957584e8&"
import script from "./AllBeneficiaryComponent.vue?vue&type=script&lang=js&"
export * from "./AllBeneficiaryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports